"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStore = exports.StoreProvider = exports.StateContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../utils");

var _configState = require("./configState");

var _authState = require("./authState");

var _appState = require("./appState");

var _editorState = require("./editorState");

var _cmsState = require("./cmsState");

var StateContext = /*#__PURE__*/(0, _react.createContext)({});
exports.StateContext = StateContext;

var StoreProvider = function StoreProvider(_ref) {
  var children = _ref.children,
      source = _ref.source,
      settings = _ref.settings,
      _ref$siteID = _ref.siteID,
      siteID = _ref$siteID === void 0 ? 'default' : _ref$siteID,
      fields = _ref.fields;
  var config = {
    source: source,
    settings: settings,
    siteID: siteID,
    fields: (0, _utils.formatFields)(fields)
  };
  var initialState = {
    config: config,
    authState: _authState.authState,
    appState: _appState.appState,
    editorState: _editorState.editorState,
    cmsState: _cmsState.cmsState
  };

  var reducer = function reducer(_ref2, action) {
    var authState = _ref2.authState,
        appState = _ref2.appState,
        editorState = _ref2.editorState,
        cmsState = _ref2.cmsState;
    return {
      config: (0, _configState.configReducer)(config, action),
      authState: (0, _authState.authReducer)(authState, action),
      appState: (0, _appState.appReducer)(appState, action),
      editorState: (0, _editorState.editorReducer)(editorState, action),
      cmsState: (0, _cmsState.sitesReducer)(cmsState, action)
    };
  };

  return /*#__PURE__*/_react.default.createElement(StateContext.Provider, {
    value: (0, _react.useReducer)(reducer, initialState)
  }, children);
};

exports.StoreProvider = StoreProvider;

var useStore = function useStore() {
  return (0, _react.useContext)(StateContext);
};

exports.useStore = useStore;